/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BpPilot } from '../../models/bp-pilot';

export interface GetActiveBpPilots$Params {
  bpGuid: string;
}

export function getActiveBpPilots(http: HttpClient, rootUrl: string, params: GetActiveBpPilots$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BpPilot>>> {
  const rb = new RequestBuilder(rootUrl, getActiveBpPilots.PATH, 'get');
  if (params) {
    rb.path('bpGuid', params.bpGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BpPilot>>;
    })
  );
}

getActiveBpPilots.PATH = '/pilots/bp-pilots/{bpGuid}';
